import { useSelector } from '@tabeeb/store'

import { Paper } from '@mui/material'

import { getFormCounterProps } from '@tabeeb/modules/forms/selectors'
import { Stack, Body2, Subheader3 } from '@collaborate-health/uikit'
import { ElementRenderer } from '@collaborate-health/forms'
import { AICounterResponse } from '@tabeeb/contracts/main-api/swagger-main-api'

const FormCounter: React.FC<ElementRenderer<'aiCounter', AICounterResponse>> = ({ element, children }) => {
  const counter = element.meta
  const { label, text, countPerPage, showPerPageCount, disabled, color } = useSelector((state) =>
    getFormCounterProps(state, { counter })
  )

  if (disabled) {
    return null
  }

  return (
    <Paper variant='outlined' sx={{ position: 'relative' }}>
      <Stack p={1} spacing={1}>
        <Subheader3 fontWeight={600}>{label}</Subheader3>
        {showPerPageCount && (
          <Stack direction='row' alignItems='center' spacing={1}>
            <Body2 fontWeight={500}>Amount per page:</Body2>
            <Body2>{countPerPage}</Body2>
          </Stack>
        )}
        <Stack direction='row' alignItems='center' spacing={1}>
          <Body2 fontWeight={500}>Total per session:</Body2>
          <Body2 sx={{ color }}>{text}</Body2>
        </Stack>
      </Stack>
      {children}
    </Paper>
  )
}

export default FormCounter

